import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { DaysToRelease } from './DaysToRelease';

export class DaysToReleaseFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [DaysToRelease];
  }

  get title() {
    return terminology('Days to release');
  }
}
